"use client";

interface BillingToggleProps {
  isAnnual: boolean;
  setIsAnnual: (value: boolean) => void;
}

export default function BillingToggle({ isAnnual, setIsAnnual }: BillingToggleProps) {
  return (
    <div className="flex items-center justify-center gap-2 sm:gap-4 mb-10 sm:mb-20">
      <span className={!isAnnual ? "text-white" : "text-gray-400"}>Monthly</span>
      <button
        onClick={() => setIsAnnual(!isAnnual)}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors
          ${isAnnual ? 'bg-white' : 'bg-gray-600'}`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-black transition-transform
            ${isAnnual ? 'translate-x-6' : 'translate-x-1'}`}
        />
      </button>
      <span className={isAnnual ? "text-white" : "text-gray-400"}>
        Annual <span className="text-emerald-500 text-sm">(Save 20%)</span>
      </span>
    </div>
  );
}